export const checkPhoneNumber = (nb: string) => {
  const regex = /^((\+)|[0-9])?([0-9]{4,15})$/;
  if (nb && regex.test(nb)) {
    return true;
  }
  return false;
};
